import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditBuddyMatch = props => {
  return (
    <Edit
      title='Edit Buddy Match'
      fields={fields}
      apiPath={`admin/buddy_matches/${props.params.buddyMatchId}`}
      successRedirectPath='/security/buddy-matches'
      buildMenuItems={menuItems}
    />
  )
}

export default EditBuddyMatch
